import $ from 'jquery';
import { querySubscription } from '~/theseus';

let accountId = null;

querySubscription('account', (id) => {
  accountId = id;
});

const lb_dom = `
  <div class='lightbox lightbox--hidden'>
    <div class='lightbox__container'>
      <p class='lightbox__status lightbox__status--loading'>Loading...</p>
      <a class='lightbox__fb-link hidden' href='#' target='_blank'></a>
      <div class='lightbox__link-container'>
        <a class='lightbox__dashboard hidden' href='/'>Go to Dashboard</a>
        <a class='lightbox__review hidden' href='#'>Review Your Work</a>
        <a class='lightbox__ads-man hidden' href='#' target='_blank'>Go To Ads Manager</a>
      </div>
    </div>
    <div class='lightbox__close hidden'></div>
  </div>
`;

export const lb_cust_img = `
  <div class='lightbox c-img'>
    <div class='c-img__container'>
      <div class='c-img__header'>
        <h2>Use A Custom Image</h2>
        <p class='description'>Click on an image or upload a new one to use it on this sub creative</p>
        <p>If advertising on Instagram, make sure your image is at least 600px by 600px.</p>
        <div class='c-img__gallery-toggle'>
          <div class='tog-4'></div>
          <div class='tog-switch'></div>
          <div class='tog-2'></div>
        </div>
      </div>
      <div class='c-img__image-gallery'></div>
      <form id='upload_img' class='c-img__upload' method='post' enctype='multipart/form-data' target='upload_target' >
        <div class='c-img__upload-row'>
          <input id='image_file' class='c-img__file' type='file' name='image_file' accept='image/png,image/jpeg,image/gif'/>
          <label for='image_file'></label>
        </div>
      </form>
    </div>
    <div class='lightbox__close'></div>
  </div>
`;

export function prompt_leave() {
  window.onbeforeunload = function () { return 'Your post has not finished processing.'; };
}

export function disable_prompt_leave() { window.onbeforeunload = null; }

export function close_lb() {
  $('.lightbox').remove();
  disable_prompt_leave();
}

/**
 * Legacy modal module used in old frontend. Eventually this should be replaced
 * by Modal component
 */
export function lb(msg, msg_status, post_id, campaign_id, show_dash, show_stay) {
  close_lb();
  $('body').append(lb_dom);
  $('body').on('keyup', (e) => {
    if (e.keyCode == 27) { close_lb(); }
  });
  if (msg_status == 'success' || msg_status == 'fail') {
    disable_prompt_leave();
    $('.lightbox__close').removeClass('hidden');
    $('.lightbox__close, .lightbox__review').on('click', close_lb);
    $('.lightbox').on('click', (e) => {
      if ($(e.target).hasClass('lightbox')) { close_lb(); }
    });
  } else {
    $('.lightbox__close').addClass('hidden');
    prompt_leave();
  }
  if (msg) {
    $('.lightbox').removeClass('lightbox--hidden');
    $('.lightbox__status').removeClass('lightbox__status--loading');
    $('.lightbox__status').removeClass('lightbox__status--success');
    $('.lightbox__status').removeClass('lightbox__status--fail');
    $('.lightbox__status').addClass(`lightbox__status--${msg_status}`).html(msg);
  } else {
    close_lb();
  }
  if (post_id) {
    $('.lightbox__fb-link').attr('href', `https://facebook.com/${post_id}`).html(`https://facebook.com/${post_id}`);
    $('.lightbox__fb-link').removeClass('hidden');
  } else {
    $('.lightbox__fb-link').addClass('hidden');
  }
  if (campaign_id) {
    $('.lightbox__ads-man').removeClass('hidden').attr('href', `https://facebook.com/ads/manager/campaign/adsets/?act=${accountId}&ids=${campaign_id}`);
  } else {
    $('.lightbox__ads-man').addClass('hidden');
  }
  if (show_dash) {
    $('.lightbox__dashboard').removeClass('hidden');
  } else {
    $('.lightbox__dashboard').addClass('hidden');
  }
  if (show_stay) {
    $('.lightbox__review').removeClass('hidden');
  } else {
    $('.lightbox__review').addClass('hidden');
  }
}
